import { Action } from '@ngrx/store';

export class StockResearchAdvicesAction implements Action {

    public static getAdvices: string = '[Research] getAdvices';
    public static cleanAdvices: string = '[Research] cleanAdvices';
    public static getAdvicesError: string = '[Research] getAdvicesError';
    public static getAdvicesSuccess: string = '[Research] getAdvicesSuccess';

    public static getAdvice: string = '[Research] getAdvice';
    public static cleanAdvice: string = '[Research] cleanAdvice';
    public static getAdviceError: string = '[Research] getAdviceError';
    public static getAdviceSuccess: string = '[Research] getAdviceSuccess';

    public static adviceNotFound: string = '[Research] adviceNotFound';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
